import { render } from "./WishlistCard.vue?vue&type=template&id=567907ab&scoped=true"
import script from "./WishlistCard.vue?vue&type=script&lang=js"
export * from "./WishlistCard.vue?vue&type=script&lang=js"

import "./WishlistCard.vue?vue&type=style&index=0&id=567907ab&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dotter/dotter/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-567907ab"]])

export default __exports__